import globalContext from 'Lib/globalContext';

function getEnvironmentContext() {
  return {
    environment: process.env.DEPLOY_ENV || process.env.NODE_ENV || 'development',
  };
}

function getContext(context: any | undefined) {
  return Object.assign(getEnvironmentContext(), globalContext, context);
}

export default {
  getContext,
};
